module.exports = __webpack_public_path__ + "static/Gravity-7ed5d3dfa1c25a00c83f5fd007cc0828.jpg";